/**
 * Money formatter with pluggable currency.
 *
 * Currency defaults to "USD" (LuxosGroup HR is USD-first).
 * Later, we can resolve currency from the active company via CompanyScopeContext.
 */

const CURRENCY_SUFFIX = {
  USD: '$',
  EUR: '€',
  FC: 'FC',
  CDF: 'FC',
  XAF: 'FCFA',
};

const CURRENCY_LOCALE = {
  USD: 'en-US',
  EUR: 'fr-FR',
  FC: 'fr-FR',
  CDF: 'fr-FR',
  XAF: 'fr-FR',
};

export function formatMoney(value, currency = 'USD') {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return '-';
  const cur = (currency || 'USD').toUpperCase();
  const locale = CURRENCY_LOCALE[cur] || 'en-US';
  const suffix = CURRENCY_SUFFIX[cur] || cur;
  const formatted = new Intl.NumberFormat(locale, { maximumFractionDigits: 0 }).format(Number(value));
  // Put the $ before, others after
  if (cur === 'USD') return `${suffix}${formatted}`;
  return `${formatted} ${suffix}`;
}

export function currencyLabel(currency = 'USD') {
  const cur = (currency || 'USD').toUpperCase();
  return CURRENCY_SUFFIX[cur] || cur;
}
